import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetConfiguration,
  fetchPutConfiguration,
  cleanUpConfiguration,
  cleanUpMessageConfiguration
} from 'state-managament/configuration.slice';

export default function useConfiguration(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.configuration);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpConfiguration());
  const cleanUpMessage = () => dispatch(cleanUpMessageConfiguration());
  const getConfiguration = () => dispatch(fetchGetConfiguration());
  const putConfiguration = (args) => dispatch(fetchPutConfiguration(args));

  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getConfiguration,
    putConfiguration,
  };

}
